import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'
import { usePermission } from 'enrollment-platform/rbac/usePermission'

/**
 * Whether the current user may perform WRITE actions in Payment Reconciliation —
 * allocate, absorb, EE-paid, refund, deallocate, delete payment, resolve/flag/
 * unflag issue, set expected price, set pull date, link/unlink Zendesk ticket.
 *
 * Mirrors the EPS `AbilityGuard(Write, PaymentReconciliation)` guarding every
 * reconciliation-v2 mutation endpoint. UI ergonomics only — the server guard is
 * the real boundary. When the `admin.rbac-enforcement-enabled` flag is off,
 * `usePermission` returns `allowed: true` (see its kill-switch), so behavior is
 * unchanged until enforcement is turned on.
 *
 * `isLoading` lets callers avoid flashing a control before the ability resolves.
 */
export function useCanWriteReconciliation(): {
  allowed: boolean
  isLoading: boolean
  isError: boolean
} {
  return usePermission(RbacActions.Write, RbacSubjects.PaymentReconciliation)
}
